import React, { useEffect, useState } from 'react';
import { Container, Card, Form, Table, InputGroup, Button, ButtonGroup, Col, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getEmployeesChronically, updateSearch, postsearchText, getEmployeesProbation, resetList, dismissEmployee, postsearchTextProbation } from "../../3.Store/EmployeeSlice";
import { ThreeDots } from 'react-loader-spinner';
import Pagination from '../../2.Commons/Pagination';

const EmployeeList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [table, setTable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const employeeLists = useSelector(state => state.EmployeeSlice.employees);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 20; // Number of items per page
    const totalPages = Math.ceil(employeeLists.length / pageSize);

    const employeeListsProbation = useSelector(state => state.EmployeeSlice.employees_probation);
    const [currentPage1, setCurrentPage1] = useState(1);
    const totalPages1 = Math.ceil(employeeListsProbation.length / pageSize);

    const getSearchParamsFromQuery = () => {
        const params = new URLSearchParams(location.search);
        const searchText = params.get('searchText') || '';
        const active = params.get('active') || '1';
        return { searchText, active };
    };

    const { searchText: initialSearchText, active: initialActive } = getSearchParamsFromQuery();

    const [searchText, setSearchText] = useState(initialSearchText);
    const [active, setActive] = useState(parseInt(initialActive, 10));

    const role = JSON.parse(localStorage.getItem("roles"));
    
    useEffect(() => {

        if (!role || !role.includes("HR-EMP-MGT")) {  // Check required role 
            localStorage.clear(); 
            window.location.href = "/Login"; 
        }

        const search = {
            searchText: initialSearchText,
            active: parseInt(initialActive, 10),
        };
        dispatch(updateSearch(search));
        setSearchText(initialSearchText);
        setActive(parseInt(initialActive, 10));
        if (initialSearchText || initialActive !== '0') {
            handleBtnSearch(searchText, active);
        }
    }, [initialSearchText, initialActive]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleBtnSearch();
        }
    };

    const handleBtnSearch = (searchTextOverride = searchText, activeOverride = active) => {
        setTable(true);
        setLoading(true);
        setCurrentPage(1);
        setCurrentPage1(1);
        dispatch(resetList());
        const entity = { searchText: searchTextOverride, active: activeOverride };
        dispatch(updateSearch(entity));
        if (searchTextOverride === "") {
            dispatch(getEmployeesChronically())
                // .then(() => dispatch(getEmployeesProbation()))
                .then(() => setLoading(false))
                .catch(() => setLoading(false));
        } else {
            dispatch(postsearchText(entity))
                // .then(() => dispatch(postsearchTextProbation(entity)))
                .then(() => setLoading(false))
                .catch(() => setLoading(false));
        }
    };

    const handleCheckboxChange = () => {
        const updatedActive = active === 1 ? 0 : 1;
        setActive(updatedActive);
        const entity = { searchText, active: updatedActive };
        dispatch(updateSearch(entity));
        handleBtnSearch(searchText, updatedActive);
    };

    const handleClickView = (id) => {
        navigate(`/EmployeeForm/${id}?searchText=${searchText}&active=${active}`);
    };

    const handleBtnCreate = () => {
        navigate(`/EmployeeForm?searchText=${searchText}&active=${active}`);
    };

    const handlePreviousPage = () => {
        setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };  

    const renderStaffList = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize, employeeLists.length);
    
        return employeeLists
          .slice(startIndex, endIndex)
          .map(employee => (
            <tr key={employee.id} style={{ cursor: "pointer" }}>
                {isMobile ? (
                    <>
                        {/* <td onClick={() => handleClickView(employee.id)}>{employee.fullname}</td> */}
                        <td onClick={() => handleClickView(employee.id)}>
                            {employee.fullname
                                .toLowerCase()
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(' ')}
                            <br/>
                            <small style={{ color: 'gray' }}>{employee.username}</small>
                        </td>
                        {/* <td onClick={() => handleClickView(employee.id)}>{employee.username}</td> */}
                        <td className="text-center align-middle" onClick={() => handleClickView(employee.id)}>{employee.status.description}</td>
                        <td className="text-center align-middle" onClick={() => handleClickView(employee.id)}>
                            <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
                        </td>
                    </>
                ) : (
                    <>
                        {/* <td onClick={() => handleClickView(employee.id)}>{employee.fullname}</td> */}
                        <td onClick={() => handleClickView(employee.id)}>
                            {employee.fullname
                                .toLowerCase()
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(' ')}
                        </td>
                        <td onClick={() => handleClickView(employee.id)}>{employee.username}</td>
                        <td onClick={() => handleClickView(employee.id)}>{employee.company.description}</td>
                        <td className="text-center align-middle" onClick={() => handleClickView(employee.id)}>{employee.status.description}</td>
                        <td className="text-center align-middle" onClick={() => handleClickView(employee.id)}>
                            <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
                        </td>
                    </>
                )}
            </tr>
          ));
    };

    return (
        <div className="ContainerContent2">
        {loading && (
            <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: '9999',
            }}
            />
        )}
        <Card className="CardContent">
            <div className="d-flex justify-content-between">
                <ButtonGroup className="my-2">
                    <Button className="Button" onClick={() => navigate("/")}>
                    Back
                    </Button>
                </ButtonGroup>
            </div>

            <h1 className="TitleHeader">Employees</h1>

            <InputGroup className="mb-3">
            <Form.Control placeholder="Search" value={searchText} onChange={handleSearch} onKeyPress={handleKeyPress} />
            <Button className="SearchIconBtn" onClick={() => handleBtnSearch(searchText, active)}>
                <FontAwesomeIcon icon={faSearch} />
            </Button>
            </InputGroup>

            <div className="FormLabel">
                <Form.Check 
                    inline 
                    type="checkbox" 
                    checked={active === 1} 
                    label="Active Employee Only"
                    onChange={handleCheckboxChange}
                />
            </div>

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                handlePageChange={handlePageChange}
            />

            {!loading && table && (
            <>
                <Table className="my-fixed-table" style={{ fontSize: "14px" }} >
                    <thead>
                        <tr>
                            {isMobile ? (
                                <>
                                    <th style={{ width: "55%" }}>Staff</th>
                                    <th style={{ width: "25%" }} className="text-center align-middle">Status</th>
                                    <th style={{ width: "20%" }} className="text-center align-middle">Action</th>
                                </>
                            ) : (
                                <>
                                    <th style={{ width: "50px" }}>Staff</th>
                                    <th style={{ width: "20px" }}>Username</th>
                                    <th style={{ width: "35px" }}>Company</th>
                                    <th className="text-center align-middle" style={{ width: "5px" }}>Status</th>
                                    <th className="text-center align-middle" style={{ width: "5px" }}>Action</th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {employeeLists.length > 0 ? (
                            renderStaffList()
                        ) : (
                            <tr>
                                {/* <td colSpan="5">No results found</td> */}
                                <td colSpan={isMobile ? "3" : "5"}>No results found</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </>
            )}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                handlePageChange={handlePageChange}
            />
            
            <div className="d-flex justify-content-between">
                <ButtonGroup className="my-2">
                    <Button className="Button" onClick={() => navigate("/")}>
                    Back
                    </Button>
                </ButtonGroup>
                &nbsp; &nbsp;
                <ButtonGroup className="my-2">
                    <Button className="Button" onClick={handleBtnCreate}>
                    Add
                    </Button>
                </ButtonGroup>
            </div>
        </Card>
        </div>
    );
};

export default EmployeeList;